import React, { useRef, useState } from 'react';

// Accessible tabs — full WAI-ARIA tabs pattern (roving tabindex, arrow-key
// navigation, Home/End) with zero dependencies. Styles in
// styles/components.css (.cs-tabs / .cs-tab / .cs-tabpanel).
//
//   <Tabs
//     tabs={[
//       { id: 'overview', label: 'Overview', render: () => <Overview /> },
//       { id: 'logs', label: 'Logs', render: () => <Logs /> },
//     ]}
//   />
//
// Panels render lazily (only the active one mounts), which is what you want
// for tabs holding onSnapshot subscriptions.
export default function Tabs({ tabs, initial, onChange }) {
  const [active, setActive] = useState(initial || (tabs[0] && tabs[0].id));
  const listRef = useRef(null);

  const select = (id) => {
    setActive(id);
    if (onChange) onChange(id);
  };

  const onKeyDown = (e) => {
    const idx = tabs.findIndex((t) => t.id === active);
    let next = -1;
    if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = tabs.length - 1;
    if (next === -1) return;
    e.preventDefault();
    select(tabs[next].id);
    const btn = listRef.current && listRef.current.children[next];
    if (btn) btn.focus();
  };

  const current = tabs.find((t) => t.id === active) || tabs[0];

  return (
    <div>
      <div className="cs-tabs" role="tablist" ref={listRef} onKeyDown={onKeyDown}>
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            id={`tab-${t.id}`}
            className="cs-tab"
            aria-selected={t.id === active}
            aria-controls={`panel-${t.id}`}
            tabIndex={t.id === active ? 0 : -1}
            onClick={() => select(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {current && (
        <div
          className="cs-tabpanel"
          role="tabpanel"
          id={`panel-${current.id}`}
          aria-labelledby={`tab-${current.id}`}
        >
          {current.render()}
        </div>
      )}
    </div>
  );
}
